export const changeItemIndex = (arr, from, to) => {
  // remove `from` item and store it
  var f = arr.splice(from, 1)[0];
  // insert stored item into position `to`
  arr.splice(to, 0, f);

  return arr
}